import { render, staticRenderFns } from "./team.vue?vue&type=template&id=c852a3f6&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports